export default __webpack_public_path__ + "static/11-cedb81105ef82e6e3a6bcba35d5da4e2.png";